import Program from './Program';

export default function ProgramPage() {
    return <Program />;
}
